import { useEffect, useState } from "react";
import { api, type Product } from "../api";
import { haptic, openInvoice } from "../platform";
import { Overlay, Spinner } from "../ui";

const PERIODS: { days: number; label: string }[] = [
  { days: 30, label: "месяц" },
  { days: 90, label: "3 месяца" },
  { days: 365, label: "год" },
];

const PLANS = [
  {
    id: "basic" as const,
    title: "Базовый",
    featured: false,
    points: ["Все разборы в кратком виде", "Число дня и советы", "Расчёты по любым датам"],
  },
  {
    id: "full" as const,
    title: "Полный",
    featured: true,
    points: ["Разборы в развёрнутом виде", "Рекомендации, родовые линии, главный урок", "Совместимость и детский профиль полностью"],
  },
];

export function Paywall({
  onClose,
  onPaid,
  showToast,
}: {
  onClose: () => void;
  onPaid: () => Promise<void>;
  showToast: (t: string) => void;
}) {
  const [products, setProducts] = useState<Product[] | null>(null);
  const [busy, setBusy] = useState<string | null>(null);

  useEffect(() => {
    api.catalog().then(
      (c) => setProducts(c.products),
      () => showToast("Не удалось загрузить тарифы"),
    );
  }, [showToast]);

  const buy = async (p: Product) => {
    setBusy(p.key);
    try {
      const { url } = await api.invoice(p.key);
      const status = await openInvoice(url);
      if (status === "paid") {
        haptic("success");
        showToast("Оплата прошла. Открываем доступ…");
        await onPaid();
        onClose();
      } else if (status === "failed") {
        showToast("Оплата не прошла. Попробуйте ещё раз.");
      }
    } catch {
      showToast("Не удалось создать оплату. Попробуйте позже.");
    } finally {
      setBusy(null);
    }
  };

  return (
    <Overlay title="Тарифы" onClose={onClose} tone="light">
      <div className="sheetbody">
        {!products && <Spinner />}
        {products &&
          PLANS.map((plan) => (
            <div className={`card plan${plan.featured ? " featured" : ""}`} key={plan.id}>
              <h3>{plan.title}</h3>
              <ul>
                {plan.points.map((t) => (
                  <li key={t}>{t}</li>
                ))}
              </ul>
              <div className="periods">
                {PERIODS.map((per) => {
                  const p = products.find((x) => x.plan === plan.id && x.periodDays === per.days);
                  if (!p) return <span key={per.days} />;
                  return (
                    <button key={per.days} disabled={busy !== null} onClick={() => void buy(p)}>
                      <span>{per.label}</span>
                      <b>{busy === p.key ? "…" : `${p.stars} ⭐`}</b>
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        <p className="sub">
          Оплата — звёздами Telegram. Помесячные тарифы продлеваются автоматически; отменить можно в настройках подписок Telegram.
        </p>
      </div>
    </Overlay>
  );
}
